/**
 * Accès de l'interface par rôle. `null` = tout est accessible. Les
 * préfixes couvrent aussi les sous-routes (« /colis » couvre « /colis/123 »).
 * Cette table pilote les menus (MainLayout) ET la redirection des routes
 * (ProtectedRoute) ; l'API applique ses propres contrôles de rôle.
 */
const STAFF_COMMON = [
  '/dashboard',
  '/colis',
  '/create-colis',
  '/national-transport',
  '/cargo-international',
  '/ecommerce/new',
  '/expeditions',
  '/livreurs',
  '/factures',
  '/notifications',
  '/transit',
  '/profile',
];

const ACCESS: Record<string, string[] | null> = {
  super_admin: null,
  admin_entreprise: null,
  // Manager de hub : opérations + pilotage, sans réglages ni portefeuille SMS
  manager_hub: [...STAFF_COMMON, '/reseau', '/reports', '/reconciliation', '/livreur-wallet'],
  agent_origine: STAFF_COMMON,
  agent_destination: STAFF_COMMON,
  livreur: ['/livreur-app', '/profile'],
  particulier: ['/mes-envois', '/profile'],
  vendeur: ['/vendeur'],
};

const HOME: Record<string, string> = {
  super_admin: '/select-tenant',
  livreur: '/livreur-app',
  particulier: '/mes-envois',
  vendeur: '/vendeur',
};

export const roleHome = (role?: string | null): string => (role && HOME[role]) || '/dashboard';

export const canAccess = (role: string | undefined | null, path: string): boolean => {
  if (!role) return false;
  const allowed = role in ACCESS ? ACCESS[role] : STAFF_COMMON;
  if (allowed === null) return true;
  return allowed.some((p) => path === p || path.startsWith(`${p}/`));
};
